module.exports = __webpack_public_path__ + "static/media/4.3d71c919.jpg";